class SwiperComponent extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector("[data-swiper]");
    if (!container) return;

    const config = JSON.parse(container.dataset.swiperConfig || "{}");
    const pagination = this.querySelector("[data-swiper-pagination]");
    const prevEl = this.querySelector("[data-swiper-prev]");
    const nextEl = this.querySelector("[data-swiper-next]");

    if (pagination) {
      config.pagination = {
        el: pagination,
        clickable: true,
        ...config.pagination,
      };
    }

    if (prevEl && nextEl) {
      config.navigation = {
        prevEl,
        nextEl,
        ...config.navigation,
      };
    }

    this.swiper = new window.Swiper(container, config);
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get("swiper-component")) {
  customElements.define("swiper-component", SwiperComponent);
}
